import { ReviewCycleStatusEnum } from '@/types/schema';

import { ReviewCycleCardFragment } from './fragments/generated/SkillReviewCard';

const getProgress = (content: ReviewCycleCardFragment) => {
  const total = Number(content.reviewerMetrics?.totalReviewsCount);
  const completed = total - Number(content.reviewerMetrics?.pendingReviewsCount);
  const progress = (completed / total) * 100;

  return Number.isNaN(progress) ? undefined : progress;
};

const useAdaptSkillReview = (content: ReviewCycleCardFragment) => {
  const { description } = content;

  return {
    name: content.title,
    description: description,
    progress: getProgress(content),
    isOverDue:
      Number(content.reviewerMetrics?.pendingReviewsCount) > 0 &&
      content.status === ReviewCycleStatusEnum.Completed,
  };
};

export default useAdaptSkillReview;
